var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user" }, [
    _c("div", { staticClass: "title" }, [_vm._v("App用户分析")]),
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "today-register" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "head" }, [_vm._v("今日注册用户")]),
          _c("div", { staticClass: "num" }, [
            _vm._v(_vm._s(_vm.devicesData.tregistrants)),
          ]),
        ]),
        _c("div", { staticClass: "right" }, [
          _vm._v("昨日：" + _vm._s(_vm.devicesData.yregistrants)),
        ]),
      ]),
      _c("div", { staticClass: "accumulate-register" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "head" }, [_vm._v("累计注册用户")]),
          _c("div", { staticClass: "num" }, [
            _vm._v(_vm._s(_vm.devicesData.totalRegistrants)),
          ]),
        ]),
        _c("div", { staticClass: "right" }),
      ]),
      _c("div", { staticClass: "today-active" }, [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "head" }, [_vm._v("今日活跃用户")]),
          _c("div", { staticClass: "num" }, [
            _vm._v(_vm._s(_vm.devicesData.tactiveUser)),
          ]),
        ]),
        _c("div", { staticClass: "right" }, [
          _vm._v("昨日：" + _vm._s(_vm.devicesData.yactiveUser)),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "search" }, [
      _c("div", { staticClass: "name" }, [_vm._v("用户趋势")]),
      _c(
        "div",
        { staticClass: "search-right" },
        [
          _c("div", { staticClass: "tab" }, [
            _c(
              "div",
              {
                staticClass: "day",
                class: { active: _vm.dateType === "day" },
                on: {
                  click: function ($event) {
                    return _vm.handleDate("day")
                  },
                },
              },
              [_vm._v("按日查询")]
            ),
            _c(
              "div",
              {
                staticClass: "mounth",
                class: { active: _vm.dateType === "mounth" },
                on: {
                  click: function ($event) {
                    return _vm.handleDate("mounth")
                  },
                },
              },
              [_vm._v("按月查询")]
            ),
          ]),
          _c("el-date-picker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dateType === "day",
                expression: "dateType === 'day'",
              },
            ],
            ref: "datePicker",
            staticClass: "date-picker",
            attrs: {
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "picker-options": _vm.pickerOptions,
              clearable: "",
            },
            on: {
              blur: function ($event) {
                _vm.isRestart = true
              },
              change: _vm.handleFormat,
            },
            model: {
              value: _vm.dayValue,
              callback: function ($$v) {
                _vm.dayValue = $$v
              },
              expression: "dayValue",
            },
          }),
          _c("el-date-picker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dateType === "mounth",
                expression: "dateType === 'mounth'",
              },
            ],
            ref: "monthPicker",
            staticClass: "date-picker",
            attrs: {
              type: "monthrange",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "picker-options": _vm.pickerMounthOptions,
              clearable: "",
            },
            on: {
              blur: function ($event) {
                _vm.isRestart = true
              },
              change: _vm.handleFormat,
            },
            model: {
              value: _vm.mounthValue,
              callback: function ($$v) {
                _vm.mounthValue = $$v
              },
              expression: "mounthValue",
            },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "register-box" }, [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("div", {}, [_vm._v("注册用户数")]),
          _c(
            "el-button",
            {
              staticClass: "button-container",
              attrs: { type: "primary", size: "14" },
              on: {
                click: function ($event) {
                  return _vm.handleExports("registers")
                },
              },
            },
            [_vm._v("导出")]
          ),
        ],
        1
      ),
      _c("div", {
        ref: "registerEcharts",
        staticStyle: { height: "420px" },
        attrs: { id: "main" },
      }),
    ]),
    _c("div", { staticClass: "active-box" }, [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("div", {}, [_vm._v("活跃用户数")]),
          _c(
            "el-button",
            {
              staticClass: "button-container",
              attrs: { type: "primary", size: "14" },
              on: {
                click: function ($event) {
                  return _vm.handleExports("activeUser")
                },
              },
            },
            [_vm._v("导出")]
          ),
        ],
        1
      ),
      _c("div", { ref: "activeEcharts", staticStyle: { height: "420px" } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }